// extracted by mini-css-extract-plugin
export var label = "_i0-2";
export var slideContainer = "_i0-0";
export var slider = "_i0-1";